import { fg } from '@atlaskit/platform-feature-flags';
import { type CreationContextParams } from '@atlassian/conversation-assistant-external-context/types';

import { type MessageSource } from './types';

export type RemixRegenerateRequestAttributes = {
	isRemixRegenerate?: true;
	remixRegenerateSource?: 'inline-existing-node';
	contentMauiId?: string;
	mediaFileId?: string;
	remixSubtype?: string;
	remixType?: string;
};

export const getRemixRegenerateRequestAttributes = ({
	creationContextParams,
	messageSources,
}: {
	creationContextParams?: CreationContextParams;
	messageSources?: Partial<MessageSource>;
}): RemixRegenerateRequestAttributes => {
	if (fg('cc-maui-disable-edit-experience-tracker-fixes')) {
		return {};
	}

	if (messageSources?.interactionSource !== 'inlineRovoFromRemix') {
		return {};
	}

	return {
		isRemixRegenerate: true,
		remixRegenerateSource: 'inline-existing-node',
		contentMauiId: creationContextParams?.contentMauiId,
		mediaFileId: creationContextParams?.mediaFileId,
		remixType: creationContextParams?.dynamicUiType,
		remixSubtype: creationContextParams?.dynamicUiSubtype,
	};
};
